
// @vendor
const PropTypes = require('prop-types');
const React = require('react');
const { formatText } = require('core/i18n').i18n;

// @components
const { EmptyState } = require('commonsComponents/emptyState');
const { OKAccordionTable } = require('commonsComponents/OKAccordionTable');
const { OKChart } = require('commonsComponents/OKChart');
const OKLoadingErrorMessage = require('components/commons/OKLoadingErrorMessage/OKLoadingErrorMessage');
const BrokerAccordionIndexesTooltip = require('../brokerAccordionIndexesTooltip/brokerAccordionIndexesTooltip');

// @helpers
const { buildArrowIcon } = require('utilities/brokerMarketsHelper');
const { formatWithoutRound } = require('utilities/currencyHelper');
const{ taggingEventHandled } = require('utilities/taggingEventHandled');

// @constants
const {
    CHART_PROPS,
} = require('constants/brokerMarkets');
const { PROC_BROKER__MARKETS_PG_NAME } = require('utilities/tagging');

const BrokerAccordionIndexes = ({
    immBrokerExchangeIndexes,
    immBrokerMarket,
    filterIndexes
}) => {
const labelNameValue = formatText('brokerAccordionIndexes-brokerAccordionIndexes_nameValue');

    const buildChart = (index, indexesData) => {
        const chartProps = { ...CHART_PROPS };
        chartProps.showDot = false;

        if (!immBrokerMarket.get('fetchingIndexesData') && indexesData.length > 0 && indexesData[index]) {
            return (
                <OKChart
                    data={indexesData[index].reverse()}
                    dotTooltip={[false]}
                    customHeight={200}
                    showTooltip={false}
                    {...chartProps}
                    XaxisScaleType="point"
                    customTooltipContent={<BrokerAccordionIndexesTooltip nameValue={labelNameValue} showDate={false}/>}
                />
            )
        }
        return (
            <div className="broker-markets-view__empty-content-accordion">
                <EmptyState />
            </div>
        )
    }

    const buildArrowTableConten = (variation, upOrDown) => {
        const arrow = buildArrowIcon(upOrDown);
        return (
            <div>
                {arrow}
                <span>{variation} %</span>
            </div>
        )
    }

    const buildContentAccordionTable = () => {
        let indexes = immBrokerExchangeIndexes.get('indexes').toJS()
        const dataToFilter = [];
        const indexesData = immBrokerMarket.get('indexesData');
        if (filterIndexes.length > 0) {
            filterIndexes.forEach((instrument) => {
                const instrumentFound = indexes.find(elem => elem.instrumentTranslated === instrument);
                if (!!instrumentFound) {
                    const index = indexes.indexOf(instrumentFound);
                    if (indexesData.length > index) {
                        dataToFilter.push(indexesData[index]);
                    }
                }
              });
            indexes = indexes.filter((index) =>
                filterIndexes.every((indexToFilter) =>
                    index.instrumentTranslated !== indexToFilter
                )
            );
        }
        dataToFilter.forEach(data => {
                const index = indexesData.indexOf(data);
                indexesData.splice(index, 1);
        });


        const indexesAccordionTable = indexes.map((data, index) => {
            const variationPtc = formatWithoutRound(data.netChangePercentage, 2);
            const arrowSection = buildArrowTableConten(variationPtc, data.upOrDown);

            return(
                {
                    texts: [
                        data.instrumentTranslated,
                        data.last,
                        arrowSection,
                    ],
                    contentAccordion: buildChart(index, indexesData),
                }
            )
        })

        return indexesAccordionTable
    }

    const buildAccordion = () => {
        const contentAccordion = buildContentAccordionTable();
        return (
            <OKAccordionTable
                headerTitles={
                    [
                        '',
                        formatText('brokerMarketNews-lastLevelIndexes'),
                        formatText('brokerMarketNews-variationIntraDay')
                    ]
                }
                content={contentAccordion}
                onClickAccordionArrow={({contentSelected, texts}) => 
                taggingEventHandled(PROC_BROKER__MARKETS_PG_NAME, 'indexGraphToggle', contentSelected === undefined ? 'close': 'open', texts[0])}
            />
        )
    }

    const buildTableAccordion = () => {
        const loading = immBrokerExchangeIndexes.get('isFetching') && immBrokerMarket.get('fetchingIndexesData');
        const error = immBrokerExchangeIndexes.get('errorReceived') && immBrokerMarket.get('errorIndexesData');
        const accordion = buildAccordion();

        return (
            <OKLoadingErrorMessage
                isLoading={loading}
                isError={error}
                primaryTextError="error"
                iconTypeError="noitems-banking"
            >
                {accordion}
            </OKLoadingErrorMessage>
        );
    }

    return (
        buildTableAccordion()
    )


}

BrokerAccordionIndexes.propTypes = {
    immBrokerExchangeIndexes: PropTypes.object,
    immBrokerMarket: PropTypes.func,
    filterIndexes: PropTypes.array,
};

BrokerAccordionIndexes.defaultProps = {
    filterIndexes: [],
}

export { BrokerAccordionIndexes };
